import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map , timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccessTokenRequest, AccessTokenResponse } from '../models/auth.model';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private tokenUrl = `${environment.apiPrivateUrl}/api/auth/access_token  `;

  constructor(private http: HttpClient) {}

  getToken(name: string): Observable<string> {
    const body: AccessTokenRequest = { name };

    const headers = new HttpHeaders({
      'api-key': environment.apiKey
    });

    return this.http
      .post<AccessTokenResponse>(this.tokenUrl, body, { headers })
      .pipe(map(res => res.token));
  }
}
